// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
// @ts-ignore
import {get_sources} from '../get_sources';
import {use_section_scroll} from '../../lib/use_section_scroll';
import {img_url} from '../../ui/img_url';
import {Button} from '../../../../shared/button';
import {Block} from './block';
import styles from './powerback_th.module.less';
import {Settings_context} from '../../settings_ctx';

interface i_powerback {
    pref?: string;
    plan?: string;
    btn?: boolean;
    cls?: string;
}
const Powerback = ({pref, plan, btn, cls}:i_powerback)=>{
    const {theme_name} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const anim_sources = get_sources('hp_shield');
    const video_ref = useRef<HTMLVideoElement>();
    const r = useRef();
    const scrolled = use_section_scroll(r, true, {treshold: 0.3,
        max_width: 0});
    useEffect(()=>{
        if (video_ref.current && scrolled)
            return void video_ref.current.play();
    }, [scrolled]);
    const text = <Fragment>
      <h2 ref={r}>{t('Putting power back into your hands')}</h2>
      <p>
        {t('Instant protection to enhance your online '
        +'privacy')}. {t(`Browse the internet safely and anonymously`)}.
      </p>
      {btn && <Button round size="lg" cls={styles.btn}
        to={`/premium?ref=${pref}_powerback`+(plan ? `&plan=${plan}` : '')}
        arrow caption={t('Get Hola')}/>}
    </Fragment>;
    const img = <div className={styles.video}>
      {anim_sources.length && theme_name!='dark' ?
        <video muted playsInline preload="true"
        ref={video_ref}>{anim_sources}</video> : <img className="lazyload"
        alt="holy_laptop" data-src={img_url('mascot/holy_laptop.png')}/>}
    </div>;
    return <Block text={text} img={img} text_position={'left'} cls={cls}/>;
};

export {Powerback};
